import TemplateView from "../../../TemplateView"
import PermissionsBlock from "./PermissionsBlock"
import ScopeCellContainer from './ScopeCellContainer'
import {AccessRights} from "../../../constants"
import {getManagerScopeState, getTeamScopeState} from './utils'
import TeamScopeCell from "./TeamScopeCell"
import ManageScopeCell from "./ManageScopeCell"
import SimpleTooltip from '../../../SimpleTooltip'
import messageResource from '../../../messageResource'
import $ from 'jquery'
import {ManagementAssignmentsSelection} from 'constants'

export default class Permissions extends TemplateView {
    constructor($containerEl, {
        onTeamAssignmentsCellClick = () => {},
        onManagementAssignmentsCellClick = () => {}
    }) {
        super($containerEl);

        this.updateOnInit = false;

        this.state = {
            editUserIsLoggedIn: false,
            accessRights: [],
            userGroups: [],
            managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
            managementAssignmentsCounts: {
                customers: 0,
                projects: 0,
                tasks: 0,
            },
            teamAssignmentsData: {},
            disabled: false,
            isUGREnabled: false,
            isAllowedToSeeAllUsersTT: false,
            userFirstName: '',
            isURAEnabled: false,
            isBTYEnabled: false,
            isLTTEnabled: false,

            permissionsReadOnly: false,
            teamScopeReadOnly: false,
            manageScopeReadOnly: false,
        }

        this.params = {
            onTeamAssignmentsCellClick,
            onManagementAssignmentsCellClick
        }

        this.onStatePropertyChanged('editUserIsLoggedIn', () => {
            this.permissionsBlock.setState({
                editLoggedIn: this.state.editUserIsLoggedIn,
            });
        })

        this.onStatePropertyChanged('accessRights', () => {
            this.permissionsBlock.setState({
                accessRights: this.state.accessRights
            });

            this._setManageScopeCellState()
            this._setTeamScopeCellState()
        })

        this.onStatePropertyChanged('userGroups', () => {
            this._setTeamScopeCellState()
        })
        this.onAnyStatePropertyChanged(['managementAssignmentsSelection', 'managementAssignmentsCounts'], () => {
            this._setManageScopeCellState()
        })
        this.onStatePropertyChanged('teamAssignmentsData', () => {
            this._setTeamScopeCellState()
        })

        this.onStatePropertyChanged('disabled', (disabled) => {
            this.permissionsBlock.setState({
                disabled: disabled
            })
        })

        this.onAnyStatePropertyChanged(['isAllowedToSeeAllUsersTT', 'userFirstName'], () => {
            this.updateWarning()
        })

        this.onStatePropertyChanged('isURAEnabled', (enabled) => {
            this.permissionsBlock.setState({
                isURAEnabled : enabled,
            })
        })
        this.onStatePropertyChanged('isBTYEnabled', (enabled) => {
            this.permissionsBlock.setState({
                isBTYEnabled : enabled,
            })
        })
        this.onStatePropertyChanged('isLTTEnabled', (enabled) => {
            this.permissionsBlock.setState({
                isLTTEnabled : enabled,
            })
        })
        this.onStatePropertyChanged('isPTOEnabled', (enabled) => {
            this.permissionsBlock.setState({
                isPTOEnabled: enabled,
            })
        })
        this.onStatePropertyChanged('isSDBEnabled', (enabled) => {
            this.permissionsBlock.setState({
                isSDBEnabled: enabled,
            })
        })

        this.onStatePropertyChanged('permissionsReadOnly', (readOnly) => {
            this.permissionsBlock.setState({readOnly})
        })

        this.onStatePropertyChanged('teamScopeReadOnly', (readOnly) => {
            this.teamAssignmentsCell.setState({readOnly})
        })

        this.onStatePropertyChanged('manageScopeReadOnly', (readOnly) => {
            this.manageScopeCell.setState({readOnly})
        })
    }

    templateHtml() {
        return "<div class='permissions panelTab'>" +
               "    <div class='permissionSection section'>" +
               "        <div class='sectionContent'>" +
               "            <div class='permissionsBlockPlaceholder'/>" +
               "            <div class='manageScopePlaceholder'>" +
               "                <div class='scopeCellsPlaceholder'/>" +
               "                <div class='showOthersWarning'>" +
               "                    <div class='icon'/>" +
               "                    <div class='text'/>" +
               "                </div>" +
               "            </div>" +
               "        </div>" +
               "    </div>" +
               "    <div class='templatePanel'/>" +
               "</div>";
    }

    afterRender() {
        super.afterRender();
        this.$content = this.find('.sectionContent');
        this.$warning = this.find('.showOthersWarning')
        this.$warningText = this.find('.showOthersWarning .text')
        this.permissionsBlock = new PermissionsBlock(this.find('.permissionsBlockPlaceholder'), {
            permissionRowMouseIn: this._handleScopePermissionsMouseIn,
            permissionRowMouseOut: this._handleScopePermissionsMouseOut
        }).init();

        this.$templatePanel = this.find('.templatePanel');
        this.$permissionsInfoButton = this.find('.permissionsInfoButton');

        this.teamAssignmentsCell = new TeamScopeCell({
            onClickCb: this._handleTeamAssignmentsCellClick,
        })

        this.manageScopeCell = new ManageScopeCell({
            onClickCb: this._handleManageAssignmentsCellClick,
        })

        new ScopeCellContainer({
            innerElement: this.teamAssignmentsCell,
        }).init(this.find('.scopeCellsPlaceholder')).setState({
            labelKey: 'user.scope_cell.users.header'
        })

        new ScopeCellContainer({
            innerElement: this.manageScopeCell
        }).init(this.find('.scopeCellsPlaceholder')).setState({
            labelKey: 'user.scope_cell.manage_scope.header'
        })

        let showOthersTooltip = this.showOthersTooltip()
        showOthersTooltip.subscribeToMouseEvents(this.$warning)
        this.updateWarning()
    }

    _handleTeamAssignmentsCellClick = ($el, e) => {
        this.params.onTeamAssignmentsCellClick(true, e)
    }

    _handleManageAssignmentsCellClick = ($el, e) => {
        this.params.onManagementAssignmentsCellClick(e)
    }

    _handleScopePermissionsMouseIn = (accessRight) => {
        if (
            accessRight === AccessRights.GENERATE_MONEY_REPORTS ||
            accessRight === AccessRights.EDIT_HIERARCHY ||
            accessRight === AccessRights.SUBMIT_OTHER_USER_TIME_TRACK ||
            accessRight === AccessRights.MANAGE_USERS
        ) {
            this.teamAssignmentsCell.setState({
                highlighted: true
            })
            this.manageScopeCell.setState({
                highlighted: true
            })
        }
    }

    _handleScopePermissionsMouseOut = (a) => {
        this.teamAssignmentsCell.setState({
            highlighted: false
        })
        this.manageScopeCell.setState({
            highlighted: false
        })
    }

    update() {
        super.update();
    }

    _setManageScopeCellState() {
        this.manageScopeCell.setState(
            getManagerScopeState(this.state.managementAssignmentsCounts, this.state.managementAssignmentsSelection, this.state.accessRights, {
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
            })
        )
    }

    _setTeamScopeCellState() {
        this.teamAssignmentsCell.setState(getTeamScopeState(this.state.teamAssignmentsData, this.state.accessRights, {
            isURAEnabled: this.state.isURAEnabled,
            isBTYEnabled: this.state.isBTYEnabled,
        }))
    }

    updateWarning() {
        this.$warningText.text(this.state.isAllowedToSeeAllUsersTT ? messageResource.getMessage("user.panel.permissions.warning_text") : '')
        this.$warning.toggle(this.state.isAllowedToSeeAllUsersTT)
        const warningTooltipText = messageResource.getEscapedMessage(
            "user.panel.permissions.warning_tooltip.part1",
            [this.state.userFirstName]
        ) + messageResource.getMessage("user.panel.permissions.warning_tooltip.part2")
        this.showOthersTooltip().setHtml(this.state.isAllowedToSeeAllUsersTT ? warningTooltipText : '')
        this.showOthersTooltip().setEnabled(this.state.isAllowedToSeeAllUsersTT)
    }

    showOthersTooltip() {
        if (!Permissions.tooltip) {
            Permissions.tooltip = new SimpleTooltip({
                extraClass: 'userPanelPermissionsTabShowOthersTooltip',
            }).init($('body'))
        }
        return Permissions.tooltip
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/Permissions.js